import React from 'react';

import { trans, getPagePath } from '@spotahome/soyuz/client';

import { CookiesBanner } from '@spotahome/ui-library';

const COOKIES_ROUTE_ID = 'externals.cookies-policy';
const COOKIES_MESSAGE = 'landingpage.label.cookies_improve_experience';
const COOKIES_BUTTON = 'global.cookies.button';
const COOKIES_LINK_TEXT = 'landingpage.label.cookies_learn_more';

const Cookies = () => (
  <CookiesBanner
    link={getPagePath(COOKIES_ROUTE_ID)}
    linkText={trans(COOKIES_LINK_TEXT)}
    message={trans(COOKIES_MESSAGE)}
    buttonText={trans(COOKIES_BUTTON)}
  />
);

export default Cookies;
